import React from 'react'
import { ProfileCellStyles } from './Style'
import { ratingListLabel7, ratingListLabel8 } from 'keys/rating'
import { gender as genders } from 'keys'
import { secretStorage } from 'config'
import { useSelector } from 'react-redux'

const ProfileCell = (props) => {
    const { row } = props
    const { brokenDisplay } = useSelector(state => state.general)
    const isSuperuser = secretStorage.getItem("user")?.is_superuser

    const {
        first_name, gender,
        completed_battery_assessment_count, battery_hidden,
        wcpm_fluency_avg_rating_index: wcpm_fluency_index,
        wcpm_foundational_avg_rating_index: wcpm_foundational_index,

        factored_percent_accuracy_fluency_avg_rating_index,
        wpm_fluency_avg_rating_index,
    } = row.original || {}

    const read = gender == genders.female ? "קוראת" : "קורא"
    const heOrShe = gender == genders.female ? "היא" : "הוא"
    const forByGender = gender == genders.female ? "לה" : "לו"
    const performByGender = gender == genders.female ? "ביצעה" : "ביצע"

    let avgProfileText2 = {
        '1': ` שליטה מצויינת `,
        '2': ` שליטה טובה מאד `,
        '3': ` קושי קל `,
        '4': ` קושי `,
        '5': ` קושי משמעותי `,
    }

    let avgProfileText3 = {
        '1': " מצוין ",
        '2': " טוב מאד ",
        '3': " עם קושי קל ",
        '4': " עם קושי ",
        '5': " עם קושי משמעותי ",
    }

    const batteryHidden = !isSuperuser && battery_hidden

    return (
        !completed_battery_assessment_count ||
        <ProfileCellStyles
            batteryHidden={batteryHidden}
            wcpm_fluency_index={wcpm_fluency_index}
            wcpm_foundational_index={wcpm_foundational_index}
            wpm_fluency_avg_rating_index={wpm_fluency_avg_rating_index}
            factored_percent_accuracy_fluency_avg_rating_index={factored_percent_accuracy_fluency_avg_rating_index}
            className='three-dots three-lines'
        >
            {(!wcpm_foundational_index && !wcpm_fluency_index) ||
                <>
                    <div className='bold'>
                        <span className={`${brokenDisplay && 'blurred2'}`}>{first_name}</span>
                        {` ${performByGender} מבדקים של `}
                        {wcpm_foundational_index > 0 && "אבני יסוד "}
                        {wcpm_foundational_index > 0 && wcpm_fluency_index > 0 && "ו"}
                        {wcpm_fluency_index > 0 && "שטף קריאה"}
                    </div>
                    <div>
                        {wcpm_foundational_index > 0 &&
                            <>
                                {`נראה שבאבני יסוד יש ${forByGender} `}
                                <span className='wcpm_foundational'>{avgProfileText2[wcpm_foundational_index]}</span>
                            </>
                        }
                    </div>
                    <div>
                        {wcpm_foundational_index > 0 && wcpm_fluency_index > 0 && "ו"}
                        {wcpm_fluency_index > 0 &&
                            <>
                                {`שטף הקריאה `}
                                <span className="wcpm-fluency">{avgProfileText3[wcpm_fluency_index]}</span>
                                {` - ${heOrShe} ${read} `}
                                <span className='words-per-minute'>
                                    {" בקצב "}{ratingListLabel7[wpm_fluency_avg_rating_index - 1]}
                                </span>
                                {" ובצורה "}
                                <span className='percent-accuracy'>
                                    {ratingListLabel8[factored_percent_accuracy_fluency_avg_rating_index - 1]}
                                </span>
                            </>
                        }
                    </div>
                </>
            }
        </ProfileCellStyles>
    )
}

export default ProfileCell